import { useEffect, useRef } from "preact/hooks";
import { Signal, useComputed, useSignalEffect } from "@preact/signals";
import { AppHistory } from "~/core";
import { UseDialogUrlStateParams } from "./interfaces";

let popupId = 0;

const getNewUrl = (queryParam?: string) => {
    const url = new URL(window.location.href);

    if (queryParam) {
        url.searchParams.set(queryParam, "true");
    }

    return url.toString();
};

const useDialogUrlState = (
    signal: Signal<boolean>,
    { queryParam, noBack, skip, onClose }: UseDialogUrlStateParams = {},
) => {
    const popupKey = useComputed(() => `popup-${popupId++}`);
    const initialRef = useRef(false);

    useSignalEffect(() => {
        const show = signal.value;

        if (skip) {
            return;
        }

        if (show) {
            if (window.history.state?.[popupKey.peek()] !== "1") {
                window.history.pushState(
                    { [popupKey.peek()]: "1" },
                    "",
                    getNewUrl(queryParam),
                );
            }
        } else if (
            window.history.state?.[popupKey.peek()] === "1" &&
            initialRef.current &&
            !noBack
        ) {
            AppHistory.back();
        }

        initialRef.current = true;
    });

    useEffect(() => {
        if (skip) {
            return;
        }

        return AppHistory.on((e) => {
            if (signal.peek() && e.state?.[popupKey.peek()] !== "1") {
                signal.value = false;
                onClose?.();
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useDialogUrlState;
